var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 508 508",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M254,0C113.7,0,0,113.7,0,254c0,75.7,33.1,143.7,85.7,190.3C130.6,483.9,189.5,508,254,508c64.6,0,123.5-24.1,168.3-63.8C474.9,397.7,508,329.7,508,254C508,113.7,394.3,0,254,0z",
    fill: "#9c89f7"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M402.4,423.6c-13-9.7-36.6-25.8-62.3-37.7c-25.7-11.8-40.8-39.5-36.7-67.4c0-0.4,0.1-0.8,0.2-1.3c0,0,58.5-39.6,50.4-78.2c0,0,1.8,0.1,4.5-0.1c25.8-2.4,27.4-40.8,1.9-44.9c-0.2,0-0.5-0.1-0.7-0.1l-0.8-4.2c7.8-27.3,26.8-110-30.7-102c0,0-41.3-68.3-128.6-35.4C112.2,85.1,135,163.4,135,163.4l10.8,31.2c-23.5,5.8-21.3,42.1,3.7,44.4c2.7,0.2,4.6,0.1,4.6,0.1c-8.2,38.6,50.3,78.2,50.3,78.2c0.1,0.5,0.1,0.9,0.2,1.3c4,27.9-11.1,55.6-36.7,67.4c-25.8,11.9-49.3,28.1-62.3,37.7c-7.8,5.7-14.7,12.6-20,20.7c45,39.5,103.9,63.6,168.4,63.6c64.6,0,123.5-24.1,168.3-63.8C417.1,436.2,410.2,429.3,402.4,423.6z",
    fill: "#34434e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.3d2f36213cabb87ae59f54fb555da2af.svg";
export { ForwardRef as ReactComponent };